import React from "react";
import { Box, Typography } from "@mui/material";
import { colors, font } from "../theme/tokens";

// Consistent eyebrow + title heading used at the top of each section.
const SectionHeading = ({ eyebrow, title, subtitle, align = "center" }) => (
  <Box sx={{ textAlign: align, mb: { xs: 5, md: 7 } }}>
    <Typography
      sx={{
        fontSize: "13px",
        fontFamily: font.mono,
        fontWeight: 600,
        letterSpacing: "3px",
        textTransform: "uppercase",
        color: colors.accent,
        mb: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: align === "center" ? "center" : "flex-start",
        gap: 1.5,
      }}
    >
      <Box
        component="span"
        sx={{
          width: 28,
          height: 2,
          background: colors.gradPrimary,
          display: "inline-block",
        }}
      />
      {eyebrow}
    </Typography>
    <Typography
      variant="h2"
      sx={{
        fontSize: { xs: "28px", md: "38px" },
        fontFamily: font.sans,
        fontWeight: 700,
        color: colors.ink,
        lineHeight: 1.15,
        mb: subtitle ? 2 : 0,
      }}
    >
      {title}
    </Typography>
    {subtitle && (
      <Typography
        sx={{
          fontSize: { xs: "15px", md: "16px" },
          color: colors.inkSoft,
          maxWidth: 680,
          mx: align === "center" ? "auto" : 0,
          lineHeight: 1.7,
        }}
      >
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default SectionHeading;
